import { ReactElement } from 'react'
import { GetStaticPathsContext, GetStaticPropsContext, InferGetStaticPropsType } from 'next'

import Meta from '@/components/base/Meta'
import PageBuilder from '@/components/layout/Builder'
import Footer from '@/components/layout/Footer'
import Layout from '@/components/layout/Layout'
import { mapPageStaticProps } from '@/utils/page-data'
import { getPromiseFromFetch } from '@/utils/request'
import { API, MOCK_DATA } from '@/constants'

import { WPPageData, WPRoutes } from '@/types'

export default function Page(pageProps: InferGetStaticPropsType<typeof getStaticProps>) {
  return <PageBuilder pageProps={pageProps} />
}

Page.getLayout = function getLayout(page: ReactElement, pageProps: WPPageData) {
  return (
    <Layout>
      <Meta pageProps={pageProps} />
      {page}
      <Footer />
    </Layout>
  )
}

export async function getStaticProps({ params }: GetStaticPropsContext<{ routes: string[] }>) {
  const { data: pageProps } = MOCK_DATA
    ? { data: require(`@/data/pages/${params?.routes.join('/')}.json`) }
    : await getPromiseFromFetch<WPPageData>({
        method: 'get',
        url: params?.routes.join('/')
      })

  const { data: homeProps } = MOCK_DATA
    ? { data: require(`@/data/pages/home.json`) }
    : await getPromiseFromFetch<WPPageData>({
        method: 'get',
        url: `/`
      })

  return {
    props: {
      homeProps,
      ...(await mapPageStaticProps(pageProps))
    }
  }
}

export async function getStaticPaths({ defaultLocale }: GetStaticPathsContext) {
  const { data: routes } = MOCK_DATA
    ? { data: require('@/data/routes.json') as WPRoutes }
    : await getPromiseFromFetch<WPRoutes>({
        method: 'get',
        url: API.ROUTES
      })

  return {
    paths: routes.map((route) => ({
      params: { routes: route.routes.filter((item) => item !== route.locale) },
      locale: route.locale === defaultLocale ? '' : route.locale
    })),
    fallback: 'blocking' // false
  }
}
